import { render, staticRenderFns } from "./MyCourseCertificate.vue?vue&type=template&id=1476de8d"
import script from "./MyCourseCertificate.vue?vue&type=script&lang=ts"
export * from "./MyCourseCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports